<script lang="ts">
    import { Toasts } from "@utils/utilities/toasts"
    import Toast from "./Toast.svelte"
</script>

<div class="fixed z-30 h-full w-full pointer-events-none" style:padding-bottom="var(--ios-bottom)">
    <div
        class="relative gap-blockspace p-blockspace w-full h-full flex flex-col justify-end items-stretch"
    >
        {#each $Toasts as toast}
            <Toast {toast} />
        {/each}
    </div>
</div>
